import { ref as l } from "vue";
function c(...n) {
  const o = {};
  for (const e of n)
    for (const t in e)
      t in o || (o[t] = []), o[t].push(e[t]);
  const u = {};
  for (const e in o)
    o[e].length === 1 ? u[e] = o[e][0] : u[e] = (t) => {
      for (const s of o[e]) s(t);
    };
  return u;
}
const a = 300;
function m({ click: n, hold: o, prevent: u, stop: e }) {
  let t, s = a;
  const f = (i) => {
    u && i.preventDefault(), e && i.stopImmediatePropagation(), t = setTimeout(() => f(i), s), o(), s > 10 && (s = s / 2);
  }, r = (i) => {
    u && i.preventDefault(), e && i.stopImmediatePropagation(), t && (clearTimeout(t), s = a), n();
  };
  return {
    vOn: {
      mousedown: f,
      mouseup: r,
      mouseout: r
    }
  };
}
function v({ focusOut: n } = {}) {
  const o = l(!1);
  let u = null;
  function e(t) {
    u && clearInterval(u), t.type === "focus" || t.type === "focusin" ? o.value = !0 : (t.type === "blur" || t.type === "focusout") && (u = setTimeout(() => {
      o.value && (o.value = !1, n && n(t));
    }, 200));
  }
  return {
    focused: o,
    onFocusChange: e,
    vOn: {
      focus: e,
      focusin: e,
      blur: e,
      focusout: e
    }
  };
}
function p(n, { up: o, downOrHold: u }) {
  return {
    vOn: {
      keydown(e) {
        n.indexOf(e.key) !== -1 && u && u(e.key);
      },
      keyup(e) {
        n.indexOf(e.key) !== -1 && o(e.key);
      }
    }
  };
}
function y({ mouseOut: n }) {
  const o = l(!1);
  let u = null;
  function e(t) {
    u && clearInterval(u), t.type === "mouseover" || t.type === "mouseenter" ? o.value = !0 : (t.type === "mouseout" || t.type === "mouseleave") && (u = setTimeout(() => {
      o.value && (o.value = !1, n && n(t));
    }, 200));
  }
  return {
    mouse: o,
    vOn: {
      mouseover: e,
      mouseout: e
    }
  };
}
const T = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  mixEventsListener: c,
  useEvtClick: m,
  useEvtFocus: v,
  useEvtKey: p,
  useEvtMouse: y
}, Symbol.toStringTag, { value: "Module" }));
export {
  y as a,
  p as b,
  m as c,
  T as e,
  c as m,
  v as u
};
//# sourceMappingURL=events-BZdEdnD6.js.map
